import { IntlShape } from 'react-intl';

import { sharedMessages } from '@app/translations';
import {
  HoldDto,
  ItemStatus,
  ItemStatusData,
  statusIconMap,
} from '@app/constants';

import { getStatusMessage } from './getStatusMessage';

export const getRequestsStatusesData = (
  holdsData: HoldDto[],
  intl: IntlShape,
  selectConfiguredOption
): ItemStatusData[] =>
  holdsData.map(({ item, status, queuePosition, requestId }) => ({
    holdId: requestId,
    instanceId: item.instanceId,
    itemId: item.itemId,
    icon: statusIconMap[ItemStatus.onHold],
    status: ItemStatus.onHold,
    statusMessage: getStatusMessage(status, intl, queuePosition),
    actionButtonText: selectConfiguredOption(
      intl.$t(sharedMessages.removeRequest),
      intl.$t(sharedMessages.removeHold)
    ),
    isVirtualItem: item.virtual,
  }));
